import { sendEmail } from '../services/notificationService'
import getCurrentUser from './getCurrentUser'
import exceptionEmailProps from '../constants/exceptionEmailProps'
import { getStationByCode } from '../services/searchPanelServices'
import { getPdfAttributes } from '../components/BookingConfirmation/printEmailUtil'
import { addError, pushPageData } from '../utils/analytics'
import dgRestrictedSccs from '../configs/dgRestrictedSccs'
import {
	getFromLocalStorage,
	getFromSessionStorage,
} from '../utils/StorageUtils'

import i18n from '../i18n'
import store from '../redux/store'
import sessionKeys from "../constants/sessionKeys";

export const sendEmailForAssistance = async (
	exceptionType,
	setIsLoading,
	attributes,
	replacements,
	selectedFlight,
	searchFormData,
	saveBookingResponse,
	awbNo,
	hasAttachmentForException,
	emailType,
) => {
	const noRates =
		(selectedFlight &&
			selectedFlight.ratingDetails &&
			selectedFlight.ratingDetails.length &&
			selectedFlight.ratingDetails[0].grandTotal === 0) ||
			(selectedFlight && (selectedFlight.isForceQueued ||
				selectedFlight.overHangShipment ||
				selectedFlight.bigShipment))
			? true
			: false

	setIsLoading && setIsLoading(true)
	const request = await getRequest(
		exceptionType,
		attributes,
		replacements,
		selectedFlight,
		searchFormData,
		saveBookingResponse,
		awbNo,
		hasAttachmentForException,
		noRates,
		emailType,
	)


	if (request) {

		const response = await sendEmail(request)
			.then((response) => {
				setIsLoading && setIsLoading(false)
				if (response.errorDetails) {
					return false
				} else {
					return true
				}
			})
			.catch((error) => {
				setIsLoading && setIsLoading(false)
				addError('EMAIL_EXCEPTION', error)
				return false
			})
		return response
	}
	else {
		return false
	}
}


const getAnimalSum = (animalCount) => {
		let sum = 0;
		for (const item of animalCount) {
			sum += item;
		}
		return sum;
	}

const getRequest = async (
	exceptionType,
	attributes,
	replacements,
	selectedFlight,
	searchFormData,
	saveBookingResponse,
	awbNo,
	hasAttachmentForException,
	noRates,
	emailType,
) => {
	/*for multilingual*/
	
	const selectedOriginByUser = attributes?.find(ele => ele?.key === "origin")?.value;
    const isBookingRelatedMail = [
		"OVER_BOOKING",
		"OHG_BOOKING",
		"BIG_BOOKING",
		"SPOT_RATE_BOOKING",
		"QUEUED_BOOKING_NST",
		"ZERO_RATE_BOOKING",
		"OP_WEIGHT_BOOKING",
		"QUEUED_BOOKING",
		"QUEUED_BOOKING_NST",
		"QUEUED_BOOKING_RUSSIA",
		"QUEUED_BOOKING_ODD_SIZED"
	  ].includes(exceptionType)

	const t = i18n.t
	let pdfAttributes
	const userDetails = getCurrentUser()
	const emailProps = exceptionEmailProps[exceptionType]
	let stationDtls = null
	if (selectedFlight && selectedFlight.origin) {
		stationDtls = await getStationByCode(selectedFlight.origin)
	}
	if (!stationDtls && exceptionType && exceptionType === 'ALTERNATE_ROUTING_ENQUIRY'
		&& replacements && replacements['%ORG%']) {
		const selectedOrigin = replacements['%ORG%']
		stationDtls = await getStationByCode(selectedOrigin)
	}
	const gsaAgentDetails = JSON.parse(getFromLocalStorage(sessionKeys.GSA_AGENT_DETAILS))
	if (!stationDtls) {
		let defaultAirport = userDetails && userDetails.defaultAirportCode ?  userDetails.defaultAirportCode : userDetails?.stationCode
		if(gsaAgentDetails){
			defaultAirport = gsaAgentDetails.agentDefaultAirportCode || gsaAgentDetails.agentStationCode
		}
		stationDtls = await getStationByCode(defaultAirport)
	}
	const language = i18n.language;
	let dgAttachementDetails = [];
	const productCheck = attributes[6]?.value;
	const dgCheckNormal = getFromSessionStorage('ifDg')

	const dgSccCode = (JSON.parse(getFromSessionStorage('dgsccCode')))

	//check for NST sccs
	let isNscIncluded = searchFormData?.sccCodes.some((item) => item.scc === 'NST')
	const isRussiaBooking = (exceptionType === 'QUEUED_BOOKING_RUSSIA' || exceptionType === 'russiaBookingUpdate') && searchFormData?.russiaAttachementDetails?.length > 0;

	if (searchFormData?.dgAttachementDetails && !isRussiaBooking) {
		searchFormData?.dgAttachementDetails.filter(item => {

			dgAttachementDetails.push(
				{
					attachmentId: item?.attachmentId,
					fileName: item?.fileName,
					id: item?.id
				})
		})
	}
	// Adding Russia documents
	const countryDocuments = [];
	if(isRussiaBooking) {

		countryDocuments.push(...searchFormData?.russiaAttachementDetails.map(item => ({
			attachmentId: item?.attachmentId,
			fileName: item?.fileName,
			id: item?.id
		})))
	}

	let unidInfoArray = [];
	if (searchFormData?.unid) {
		searchFormData?.unid?.filter((item, index) => {

			unidInfoArray.push({
				id: item?.id,
				unid: item?.unid,
				shippingName: item?.unidName,
				packingGroup: item?.packingGroup
			})

		})
	}

	if (replacements) {
		replacements['%AGENTNAME%'] =
			userDetails && userDetails?.companyName ? userDetails?.companyName : (userDetails && userDetails?.agentCode ? userDetails?.agentCode : '')
		// replacements['%PRODUCT%'] = attributes && attributes[6]?.value ? attributes[6]?.value : ''
		replacements['%FLIGHTDATE%'] = attributes && attributes[3]?.value ? attributes[3]?.value : ''
		replacements['%ORG%'] = attributes && attributes[0]?.value ? attributes[0]?.value : ''
		replacements['%DES%'] = attributes && attributes[1]?.value ? attributes[1]?.value : ''
	}

	let agentEmail = userDetails ? userDetails.email : null;
	let contactNo = userDetails
		? userDetails.mobileNo
			? userDetails.mobileNo
			: userDetails.telephoneNo
		: null

	const { agentDetails } = store.getState().gsaAgent;
	if (agentDetails) {
		agentEmail = agentDetails?.email || agentEmail;
		contactNo = agentDetails?.contactNo || contactNo;
	}

	let userName = userDetails
		? `${userDetails.firstName ? userDetails.firstName : ''} ${userDetails.lastName ? userDetails.lastName : ''}`
		: null
	if (gsaAgentDetails && gsaAgentDetails.userName && gsaAgentDetails.userName !== '') {
		userName = gsaAgentDetails.userName
	}
	const mailAttributes = {
		body: t(emailProps?.body, {
			agentName: replacements['%AGENTNAME%'],
			description: replacements['%DESCRIPTION%'],
			flightDate: replacements['%FLIGHTDATE%'],
			ORG: replacements['%ORG%'],
			DES: replacements['%DES%'],
			AWB: replacements['%AWB%'],
			REASON: replacements['%REASON%'],
			OPENING: replacements['%OPENING%'],
			classificationType: replacements['%CLASSIFICATION%']
		}),
		agentCode: userDetails ? userDetails.agentCode : null,
		userName:userName,
		agentName: userDetails ? userDetails.companyName : null,
		agentEmail,
		contactNo,
		hasAttachments: hasAttachmentForException ? hasAttachmentForException : false,
		emailType: ((exceptionType === "dgBookingUpdate") || (exceptionType === "aviBookingUpdate") || (exceptionType === "booking_update") || (exceptionType === "russiaBookingUpdate")) ? "modifyBooking" : emailType,

	}

	if (hasAttachmentForException) {
		pdfAttributes = getPdfAttributes(
			selectedFlight,
			searchFormData,
			null,
			awbNo,
			saveBookingResponse,
			true,
			true,
			null,
			null,
			userDetails,
			noRates,
			'email',
			((exceptionType === "dgBookingUpdate") || (exceptionType === "aviBookingUpdate") || (exceptionType === "booking_update") || (exceptionType === "russiaBookingUpdate")) ? "modifyBooking" : emailType
		)
	}

	let animalCount = searchFormData?.crates.map((item) => {
		return item.pets.length
	})


	if (stationDtls && stationDtls?.emailAddress) {

		let emailAddresses = stationDtls.emailAddress.split(',')
		if(userDetails?.defaultAirportCode !== selectedOriginByUser && isBookingRelatedMail){
			const defaultOrgEmail = await getStationByCode(userDetails?.defaultAirportCode)
			emailAddresses = Array.from(new Set([...stationDtls?.emailAddress.split(','),...defaultOrgEmail?.emailAddress.split(',')]));
		}
		// replacements['%PRODUCT%'] = attributes && attributes[6]?.value ? attributes[6]?.value : ''
		replacements['%FLIGHTDATE%'] = attributes && attributes[3]?.value ? attributes[3]?.value : ''
		replacements['%ORG%'] = attributes && attributes[0]?.value ? attributes[0]?.value : ''
		replacements['%DES%'] = attributes && attributes[1]?.value ? attributes[1]?.value : ''
		replacements['%AGENTNAME%'] = userDetails && userDetails.companyName ? userDetails?.companyName : ''

		const request = {
			toEmailAddresses: emailAddresses,
			subject: getEmailSubject(
				exceptionType,
				searchFormData,
				replacements,
				attributes,
				emailProps,
				animalCount,
				dgSccCode,
				dgCheckNormal,
				t
			),
			templateName: getTemplateName(
				exceptionType,
				searchFormData,
				dgSccCode,
				dgCheckNormal,
				isNscIncluded
			),

			attributes: hasAttachmentForException ? {
				...mailAttributes,
				...pdfAttributes,
			}
				: {
					...mailAttributes,
				},
			hasAttachments: hasAttachmentForException,

			agentCode: userDetails.agentCode,
			userId: userDetails.userId,
			async: false,

			attachmentName: "Booking details",
			specializedCommodity: dgAttachementDetails,
			additionalCommodityDetails: (dgSccCode?.includes(searchFormData?.shippingItemCode?.scc)) || (dgCheckNormal && dgCheckNormal === 'true') ?
				{
					dangerousGoods: true,
					specialProvision: true,
					unidInfo: unidInfoArray
				} : null
			,
			cages: searchFormData?.shippingItemCode?.productDescription === 'Live Animals' ? searchFormData?.crates : null,
			emailType: ((exceptionType === "dgBookingUpdate") || (exceptionType === "aviBookingUpdate") || (exceptionType === "booking_update") || (exceptionType === "russiaBookingUpdate"))  ? "modifyBooking" : emailType,
			// in future, can add other country codes for other reasons if needed, 
			// for now only Russia is needed for the exception type QUEUED_BOOKING_RUSSIA
			countryCode: isRussiaBooking ? searchFormData?.destination?.countryCode : null,
			countryRelatedDocuments: countryDocuments,

		}
		if (isNscIncluded) {
			request.dimensionDetails = searchFormData.shippingType === "ULD" ? searchFormData.mixLooseDetails : searchFormData.looseDetails
		}
		if (attributes && attributes.length) {
			attributes.forEach(function (attr) {
				request.attributes[attr.key] = attr.value
			})
		}
		return request
	} else {
		return null
	}
}

// Returns the email template name based on exception type and shipment details.
const getTemplateName = (
	exceptionType,
	searchFormData,
	dgSccCode,
	dgCheckNormal,
	isNscIncluded
) => {
	if (exceptionType === "russiaBookingUpdate") {
		return "booking_modification_ru";
	}
	if (exceptionType === "dgBookingUpdate") {
		return "booking_modification_dg";
	}

	if (exceptionType === "aviBookingUpdate") {
		return "booking_modification_avi";
	}

	if(exceptionType === "QUEUED_BOOKING_RUSSIA"){
		return "exception_handling_ru";
	}

	if (
		searchFormData?.shippingItemCode?.code === "DOG" ||
		searchFormData?.shippingItemCode?.code === "CAT"
	) {
		return "exception_handling_avi";
	}

	

	if (exceptionType === "DG_ULD" || exceptionType === "DG_SP") {
		return "booking_enquiry_dg";
	}

	if (
		dgSccCode?.includes(searchFormData?.shippingItemCode?.scc) ||
		(dgCheckNormal && dgCheckNormal === 'true')
	) {
		return "booking_confirmation_dg";
	}

	if (isNscIncluded) {
		return "booking_confirmation_nst";
	}

	return "exception_handling";
};

// Builds the email subject line based on exception type and booking context.
const getEmailSubject = (
	exceptionType,
	searchFormData,
	replacements,
	attributes,
	emailProps,
	animalCount,
	dgSccCode,
	dgCheckNormal,
	t
) => {
	// Russia booking Update
	if (exceptionType === "russiaBookingUpdate") {
		return `Russia Booking Modification Request- ${searchFormData?.shippingItemCode?.description} / ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}`;
	}
	// Dangerous Goods Booking Modification
	if (exceptionType === "dgBookingUpdate") {
		return `Dangerous Goods Booking Modification Request- ${searchFormData?.shippingItemCode?.description} / ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}`;
	}

	// Pet Booking Modification
	if (exceptionType === "aviBookingUpdate") {
		return ` Pet Booking Modify - ${getAnimalSum(animalCount)} ${searchFormData?.shippingItemCode?.description} / ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}`;
	}

	// Generic Booking Update
	if (exceptionType === "booking_update") {
		return t(emailProps.subject, {
			agentName: replacements['%AGENTNAME%'],
			description: replacements['%DESCRIPTION%'],
			product: replacements['%PRODUCT%'],
			AWB: replacements['%AWB%'],
		});
	}

	// Russia bound booking
	if (exceptionType === "QUEUED_BOOKING_RUSSIA") {
		return `Russia Bound Booking Request - ${replacements['%AGENTNAME%']} / Queued / ${replacements['%AWB%']}`;
	}

	// ODF/ODP (odd-sized cargo) queued booking
	if (exceptionType === "QUEUED_BOOKING_ODD_SIZED") {
		return t(emailProps.subject, {
			classificationType: replacements['%CLASSIFICATION%'],
			AWB: replacements['%AWB%'],
			REASON: replacements['%REASON%'],
		});
	}

	// Pet Booking Request (Live Animals)
	if (
		searchFormData?.shippingItemCode?.description === 'Live Dogs' ||
		searchFormData?.shippingItemCode?.description === 'Live Cats'
	) {
		return ` Pet Booking Request - ${getAnimalSum(animalCount)} ${searchFormData?.shippingItemCode?.description} / ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}`;
	}

	// DG ULD booking enquiry
	if (exceptionType === "DG_ULD") {
		return `DG ULD booking enquiry  - ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}/  ${replacements['%AGENTNAME%']}`;
	}

	// DG Special Provision booking enquiry
	if (exceptionType === "DG_SP") {
		return `DG booking enquiry under special provision  - ${attributes && attributes[5]?.value ? attributes[5]?.value : ''} / ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}`;
	}


	// Dangerous Goods Booking Request (multiple conditions)
	const isDgScc = dgSccCode?.includes(searchFormData?.shippingItemCode?.scc);
	const isDgNormalBooking = dgCheckNormal && dgCheckNormal === 'true';
	const isDgBookingRequest = 
		(isDgScc && exceptionType !== "DG_ULD") ||
		(isDgScc && exceptionType !== "DG_SP") ||
		(isDgNormalBooking && (exceptionType !== "DG_SP" && exceptionType !== "DG_ULD"));

	if (isDgBookingRequest) {
		return `Dangerous Goods Booking Request - ${searchFormData?.shippingItemCode?.description} / ${replacements['%ORG%']}-${replacements['%DES%']} / ${replacements['%FLIGHTDATE%']}`;
	}

	// Default fallback using translation
	return t(emailProps.subject, {
		agentName: replacements['%AGENTNAME%'],
		description: replacements['%DESCRIPTION%'],
		product: replacements['%PRODUCT%'],
		AWB: replacements['%AWB%'],
		ORG: replacements['%ORG%'],
		DES: replacements['%DES%'],
	});
};

const formatString = (str, replacements) => {
	if (replacements) {
		let formattedStr = str.replace(/%\w+%/g, function (all) {
			return replacements[all] || all
		})
		return formattedStr
	} else {
		return str
	}
}
